import type { z } from "zod";

import { UserEntity } from "~/entities/user/@x/auth";

const zOut = UserEntity.zSchema.omit({
  password: true,
});
type Out = z.infer<typeof zOut>;

export { zOut };
export type { Out };
